import React from "react";
import "./OverlayComponent.scss";

function OverlayComponent({ children }) {
    return <div className="overlay">{children}</div>;
}
export default OverlayComponent;
